import React, { useEffect, useState } from 'react'
import { LinkButton } from '@zera-admin/button'
import Breadcrumb, { BreadcrumbItem } from '@zera-admin/breadcrumb'
import Page, { PageHeader } from '@zera-admin/page'
import Table from '@zera-admin/table'

import Pager from 'components/pager'
import MainLayout from 'layouts/main'
import classificationDataSetsService, {
  ClassificationDataSet,
  ClassificationDataSetResponse,
} from 'services/http/dataset/classification-data-set'

import { ClassificationDataSetListProps } from './types'

const ClassificationDataSetList: React.FunctionComponent<
  ClassificationDataSetListProps
> = () => {
  const [isLoading, setIsLoading] = useState(true)
  const [classificationDataSet, setClassificationDataSet] =
    useState<ClassificationDataSetResponse>()

  useEffect(() => {
    getClassificationDataSets()
  }, [])

  const getClassificationDataSets = async () => {
    try {
      const response = await classificationDataSetsService.get()

      setClassificationDataSet(response.data)
      setIsLoading(false)
    } catch (err) {
      console.log(err)
    }
  }

  const renderPageHeader = () => {
    const actions = (
      <LinkButton appearance="primary" href="/classification-data-set/create">
        Sınıflandırma veri seti oluştur
      </LinkButton>
    )

    const breadcrumbs = (
      <Breadcrumb>
        <BreadcrumbItem text="Anasayfa" href="/" />
        <BreadcrumbItem text="Sınıflandırma veri setleri" />
      </Breadcrumb>
    )

    const bottomBar = (
      <p>
        Tüm sınıflandırma veri setlerini görüntüleyebilir, yeni oluşturabilir,
        varolanları düzenleyebilirsiniz.
      </p>
    )

    return (
      <PageHeader
        actions={actions}
        bottomBar={bottomBar}
        breadcrumbs={breadcrumbs}
      >
        Sınıflandırma veri setleri
      </PageHeader>
    )
  }

  const renderPageTable = () => {
    const columns = [
      {
        name: 'text',
        text: 'Sınıflandırma veri seti metni',
        width: '800px',
      },
      {
        name: 'languageCode',
        text: 'Dil kodu',
      },
      {
        name: 'sourceName',
        text: 'Kaynak',
      },
      {
        name: 'trainingGroupName',
        text: 'Eğitim grubu',
      },
      {
        name: 'createdDate',
        text: 'Oluşturulma tarihi',
      },
      {
        name: 'operation',
        text: 'İşlemler ',
        width: '100px',
        render: (item: ClassificationDataSet) => (
          <LinkButton
            appearance="subtle-link"
            href={`/classification-data-set/update/${item.id}`}
          >
            Görüntüle
          </LinkButton>
        ),
      },
    ]

    if (classificationDataSet) {
      return (
        <React.Fragment>
          <Table
            columns={columns as any}
            rows={classificationDataSet.list}
            isLoading={isLoading}
            helperMessage="Aradığınız kriterlere uygun bir veri bulunamadı"
          />
          <Pager pages={classificationDataSet.pageCount} />
        </React.Fragment>
      )
    }

    return null
  }

  return (
    <MainLayout>
      <Page>
        {renderPageHeader()}
        {renderPageTable()}
      </Page>
    </MainLayout>
  )
}

export default ClassificationDataSetList
